import { useState, useContext, useCallback } from 'react'
import { arcadeApiClient } from '../apiClients'
import { AppContext } from '../providers'

interface UseReversalOutput {
  reverseTransaction: (transactionId: number) => Promise<void>
  loading: boolean
}

export const useReversal = (): UseReversalOutput => {
  const { setToast } = useContext(AppContext)
  const [loading, setLoading] = useState<boolean>(false)

  const reverseTransaction = useCallback((transactionId: number) => {
    setLoading(true)

    return arcadeApiClient
      .post(`/multi_platform/manage/transactions/reverse/${transactionId}`)
      .then(() => {
        setToast({
          status: 'success',
          description: 'Transaction successfully reversed.',
        })
      })
      .catch(error => {
        setToast({
          status: 'error',
          description:
            'There was a problem reversing this transaction. Please try again.',
        })
        throw error
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return { reverseTransaction, loading }
}
